import React, { useState } from "react";
import "./OfferingsTabContent.css";
import PivotNewContent from "./PivotNewContent";
import CoreskillNewContent from "./CoreskillNewContent";
import DeliverNewContent from "./DeliverNewContent";
import ForceNewContent from "./ForceNewContent";
import LeadNewContent from "./LeadNewContent";
// import BuildNewContent from './BuildNewContent';
import FullStack from "./offerings/FullStack";
import CertificationsContent from "./CertificationsContent";
import WhatsnewContent from "./WhatsnewContent";
import Whatscalendartabs from "./Whatscalendartabs";
import TalentAcademies from "./TalentAcademies";

function OfferingsTabContent(props) {
  const [selectedOffering, setSelectedOffering] = useState("c_tech");
  React.useEffect(() => {
    setSelectedOffering(props.menu2);
  }, [props.menu2]);

  const [selectedOffering2, setSelectedOffering2] = useState("core");
  React.useEffect(() => {
    setSelectedOffering2(props.menu1);
  }, [props.menu1]);

  console.log(selectedOffering2);
  console.log(selectedOffering);

  return (
    <>
      <div className="offeringstab-wrap">
        {/* <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class={selectedOffering2 === 'core' || selectedOffering2 === 'default' ? "nav-link active" : 'nav-link'} id="pills-core-tab" data-bs-toggle="pill" data-bs-target="#pills-core" type="button" role="tab" aria-controls="pills-core" aria-selected="true" onClick={() => {setSelectedOffering2('core');setSelectedOffering('c_tech')}}>Entry-level Tech Expressway</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class={selectedOffering2 === 'pivot' ? "nav-link active" : 'nav-link'} id="pills-pivot-tab" data-bs-toggle="pill" data-bs-target="#pills-pivot" type="button" role="tab" aria-controls="pills-pivot" aria-selected="false"  onClick={() => {setSelectedOffering2('pivot');setSelectedOffering('p_ai')}}>Upskilling/Reskilling</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class={selectedOffering2 === 'lead' ? "nav-link active" : 'nav-link'} id="pills-lead-tab" data-bs-toggle="pill" data-bs-target="#pills-lead" type="button" role="tab" aria-controls="pills-lead" aria-selected="false" onClick={() => {setSelectedOffering2('lead');setSelectedOffering('l_aspirational')}}>Executive Enablement</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class={selectedOffering2 === 'deliver' ? "nav-link active" : 'nav-link'} id="pills-deliver-tab" data-bs-toggle="pill" data-bs-target="#pills-deliver" type="button" role="tab" aria-controls="pills-deliver" aria-selected="false" onClick={() => {setSelectedOffering2('deliver');setSelectedOffering('d_agile')}}>Delivery Learning</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class={selectedOffering2 === 'force' ? "nav-link active" : 'nav-link'} id="pills-force-tab" data-bs-toggle="pill" data-bs-target="#pills-force" type="button" role="tab" aria-controls="pills-force" aria-selected="false" onClick={() => {setSelectedOffering2('force');setSelectedOffering('f_inclusion')}}>Strategic Programs</button>
                    </li>
                   
                </ul> */}
        <div className="offering-container-div">
          <ul className="offering-container">
            <li
              className={
                selectedOffering2 === "core" || selectedOffering2 === "default"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  className={
                    selectedOffering2 === "core" ||
                    selectedOffering2 === "default"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("core");
                    setSelectedOffering("c_tech");
                  }}
                >
                  Entry-level Learning
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "pivot"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "pivot"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  id="pills-pivot-tab"
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("pivot");
                    setSelectedOffering("p_ai");
                  }}
                >
                  Upskilling/Reskilling
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "lead"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "lead"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("lead");
                    setSelectedOffering("l_technology");
                  }}
                >
                  Executive Enablement
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "deliver"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "deliver"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("deliver");
                    setSelectedOffering("d_dlf");
                  }}
                >
                  Delivery Learning
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "force"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "force"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("force");
                    setSelectedOffering("f_inclusion");
                  }}
                >
                  Strategic Programs
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "fullstack"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "fullstack"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("fullstack");
                    setSelectedOffering("fs_custom");
                  }}
                >
                  Full Stack Programs
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "talent"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "talent"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("talent");
                    setSelectedOffering("t_talent");
                  }}
                >
                  Talent Academies
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "certifications"
                  ? "offering-list single-word-offering offering-list-active"
                  : "offering-list single-word-offering"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "certifications"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("certifications");
                    setSelectedOffering("f_certiprocess");
                  }}
                >
                  Certifications
                </button>
              </div>
            </li>
            <li
              className={
                selectedOffering2 === "whats"
                  ? "offering-list offering-list-active"
                  : "offering-list"
              }
            >
              <div className="offering-btn-div">
                <button
                  class={
                    selectedOffering2 === "whats"
                      ? "offering-btn offering-btn-active"
                      : "offering-btn"
                  }
                  id="pills-whats-tab"
                  type="button"
                  onClick={() => {
                    setSelectedOffering2("whats");
                    setSelectedOffering("w_new");
                  }}
                >
                  Whats New
                </button>
              </div>
            </li>
          </ul>
        </div>
        <div className="offering-tab-content">
          <div class="tab-content offering-tab-data" id="pills-tabContent">
            <div
              class={
                selectedOffering2 === "core" || selectedOffering2 === "default"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-core"
              role="tabpanel"
              aria-label="pills-core-tab"
            >
              <CoreskillNewContent
                menu2={selectedOffering}
                menu3={props.menu3}
              />
            </div>
            <div
              class={
                selectedOffering2 === "pivot"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-pivot"
              role="tabpanel"
              aria-label="pills-pivot-tab"
            >
              <PivotNewContent menu2={selectedOffering} menu3={props.menu3} />
            </div>
            <div
              class={
                selectedOffering2 === "lead"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-lead"
              role="tabpanel"
              aria-label="pills-lead-tab"
            >
              <LeadNewContent menu2={selectedOffering} menu3={props.menu3} />
            </div>
            <div
              class={
                selectedOffering2 === "deliver"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-deliver"
              role="tabpanel"
              aria-label="pills-deliver-tab"
            >
              <DeliverNewContent menu2={selectedOffering} menu3={props.menu3} />
            </div>
            <div
              class={
                selectedOffering2 === "force"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-force"
              role="tabpanel"
              aria-label="pills-force-tab"
            >
              <ForceNewContent menu2={selectedOffering} menu3={props.menu3} />
            </div>
            <div
              class={
                selectedOffering2 === "fullstack"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-fullstack"
              role="tabpanel"
              aria-label="pills-fullstack-tab"
            >
              <FullStack menu2={selectedOffering} menu3={props.menu3} />
            </div>
            <div
              class={
                selectedOffering2 === "certifications"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-certifications"
              role="tabpanel"
              aria-label="pills-certifications-tab"
            >
              <CertificationsContent
                menu2={selectedOffering}
                menu3={props.menu3}
              />
            </div>
            <div
              class={
                selectedOffering2 === "whats"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-calendar"
              role="tabpanel"
              aria-label="calendar-tab"
            >
              {/* <WhatsnewContent menu2={selectedOffering} menu3={props.menu3} /> */}
              <Whatscalendartabs menu2={selectedOffering} menu3={props.menu3} />
            </div>
            <div
              class={
                selectedOffering2 === "talent"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-talent"
              role="tabpanel"
              aria-label="pills-talent-tab"
            >
              {/* <WhatsnewContent menu2={selectedOffering} menu3={props.menu3} /> */}
              <TalentAcademies menu2={selectedOffering} menu3={props.menu3} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OfferingsTabContent;
